<template>
  <b-modal id="modalPopover" v-model="hasToUpdate" title="Ενημέρωση εφαρμογής"
    ok-only
    ok-title="Ενημέρωση Εφαρμογής"
    @ok="handleUpdate"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
  >
    <p>
      Δυστυχώς θα πρέπει να ενημερώσεις την εφαρμογή για να μπορέσεις συνεχίσεις.
    </p>
  </b-modal>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';

const deviceContext = createNamespacedHelpers('device');

export default {
  name: 'GlobalAlert',
  props: {
  },
  computed: {
    ...deviceContext.mapState({
      appVersion: state => state.appVersion,
      requiredMinVersion: state => state.requiredMinVersion,
      appStoreLink: state => state.appStoreLink,
    }),
    ...deviceContext.mapGetters([
      'hasToUpdate',
    ]),
  },
  data() {
    return {
    };
  },
  methods: {
    handleUpdate(ev) {
      ev.preventDefault();

      window.open(this.appStoreLink);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/GlobalAlert.vue